import React from 'react';

const css = `
.globe-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.globe-spinner-wrap {
  position: relative;
  perspective: 200px;
}

.globe-spinner-ring {
  position: absolute;
  inset: 0;
  border: 2px solid rgba(51, 68, 170, 0.6);
  border-radius: 50%;
}

.globe-spinner-ring:nth-child(1) {
  animation: gsSpin 3s linear infinite;
  border-color: #3344aa;
  box-shadow: 0 0 8px rgba(51, 68, 170, 0.4);
}
.globe-spinner-ring:nth-child(2) {
  animation: gsSpin 3s linear infinite reverse;
  transform: rotateY(60deg);
  border-color: #ffd700;
  box-shadow: 0 0 8px rgba(255, 215, 0, 0.3);
}
.globe-spinner-ring:nth-child(3) {
  animation: gsSpin 4s linear infinite;
  transform: rotateY(-60deg);
  border-color: #5566cc;
  box-shadow: 0 0 6px rgba(85, 102, 204, 0.3);
}
.globe-spinner-ring:nth-child(4) {
  animation: gsSpin 2.5s linear infinite reverse;
  transform: rotateX(60deg);
  border-color: rgba(255, 215, 0, 0.4);
}
.globe-spinner-ring:nth-child(5) {
  width: 50%;
  height: 50%;
  top: 25%;
  left: 25%;
  animation: gsSpin 2s linear infinite;
  border-color: #ffd700;
  box-shadow: 0 0 12px rgba(255, 215, 0, 0.5);
}

.globe-spinner-dot {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #ffd700;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 10px #ffd700, 0 0 20px rgba(255, 215, 0, 0.4);
}

@keyframes gsSpin {
  from { transform: rotateY(0deg); }
  to { transform: rotateY(360deg); }
}
`;

const GlobeSpinner = ({ size = 70 }) => (
  <>
    <style>{css}</style>
    <div className="globe-spinner">
      <div className="globe-spinner-wrap" style={{ width: size, height: size }}>
        <div className="globe-spinner-ring"></div>
        <div className="globe-spinner-ring"></div>
        <div className="globe-spinner-ring"></div>
        <div className="globe-spinner-ring"></div>
        <div className="globe-spinner-ring"></div>
        <div className="globe-spinner-dot"></div>
      </div>
    </div>
  </>
);

export default GlobeSpinner;
